import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2026-05-27 14:18:05 +0200 (Wed, 27 May 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 163319 $
//  Purpose   : domain tree table
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Icon } from 'semantic-ui-react';
// ---Framework imports
import { Actions, Sel } from 'uix/registries';
import log from 'uix/logging';
import { mapItems, items, size, values, get } from 'ldash';
import { Link, TranslatedTable } from 'uix/components';
import { useSelector, useMemo } from 'uix/hooks';
// ---Local imports
import { DomainIcon } from './icon';
// ---Globals
// <DomainTable> looks like a DomainTree with columns
export const DomainTable = ({ data = {}, columns = [], menuPortal, allDomains = false, dnameFilter, odidFilter, compact = false, flex = false, showAncestors = false, showDomainName = false, showDomainType = true })=>{
    let i18n = useSelector(Sel.i18n);
    let { dname } = useSelector(Sel.request);
    let domains = useSelector(Sel.domains);
    if (!dnameFilter && odidFilter) {
        dnameFilter = odidFilter.map((odid)=>domains.odid2name[odid]);
    }
    let subdomains = useSelector(Sel.subdomains);
    subdomains = allDomains ? values(domains.data) : subdomains;
    let ancestorDomains = useSelector(Sel.ancestorDomains);
    let allowed_names = subdomains.map((d)=>d.name);
    if (showAncestors) {
        allowed_names = [
            ...ancestorDomains.map((d)=>d.name),
            ...allowed_names
        ];
    }
    let row_data = useMemo(()=>mapItems(domains.data, (dname, ddata)=>{
            let external_data = data[ddata.id] || data[ddata.name] || {};
            //~ log.x('XXXXXXXXXX', dname, external_data)
            return {
                ...ddata,
                ...external_data
            };
        }, (dname)=>allowed_names.includes(dname) && (!dnameFilter || dnameFilter.includes(dname))), [
        dname,
        domains,
        data,
        dnameFilter
    ]);
    //~ log.x(data)
    let buildDomain = (data)=>{
        return /*#__PURE__*/ _jsxs("span", {
            style: {
                paddingLeft: `${data.level}em`
            },
            children: [
                /*#__PURE__*/ _jsx(DomainIcon, {
                    dname: data.name
                }),
                /*#__PURE__*/ _jsx(Link, {
                    lazy: true,
                    dname: data.name,
                    disabled: data.isGhost,
                    children: showDomainName ? data.name : data.description
                })
            ]
        });
    };
    let default_columns = [
        {
            Header: 'Domain',
            accessor: 'description',
            Cell: ({ value, original })=>buildDomain(original)
        }
    ];
    if (showDomainType) {
        default_columns = [
            ...default_columns,
            {
                Header: 'Type',
                accessor: 'type',
                Cell: ({ value })=>i18n.getType('domain', value)
            }
        ];
    }
    let cols = [
        ...default_columns,
        ...columns
    ];
    return /*#__PURE__*/ _jsx(TranslatedTable, {
        flex: flex,
        menuPortal: menuPortal,
        compact: compact,
        data: row_data,
        columns: cols,
        className: "-striped -highlight"
    });
};
